// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"fastBuy_wrapper__9gx2R","wrapper-inline":"fastBuy_wrapper-inline__z5OIL"};